import "../../../server_rendering";
import "../../../../js/atoms/wistia/events";
import "../../../../js/atoms/wistia/functionality";
import "../../../../js/molecules/popover/teacher-popover";
import "../../../../js/molecules/course-navigation/course-navigation-new";

import { Application } from "@hotwired/stimulus";
import DsSectionNavigation from "../../../ds/section_navigation_controller";

window.Stimulus = Application.start();
window.Stimulus.register("ds-section-navigation", DsSectionNavigation);

class CourseUnits {
  init = (params) => {
    if (params.public_access) {
      Domestika.countdown?.init();
      if (params.free_plus_url) {
        Domestika.free_plus_modal_auto.handle_without_cookie("course_units", params.free_plus_url);
        Domestika.wistiaFunctionality.initModal("course_units", params.free_plus_url);
      } else {
        Domestika.wistiaFunctionality.init();
        Domestika.wistiaFunctionality.autoScrollFromUrl(/course_lesson_/);
      }
    } else {
      Domestika.wistiaFunctionality.init();
      Domestika.wistiaFunctionality.autoScrollFromUrl(/course_lesson_/);
    }
    Domestika.sticky.stick_in_parent(".js-sticky-sidebar", ".js-main-content");
    Domestika.select_change.handle("#js-course-main-select-navigation");
    Domestika.select_change.handle("#js-course-course-select-navigation");
    Domestika.modal_reload.handle();
    if (params.micro_feedback_path) {
      Domestika.course_micro_feedback_modal.handle(params.micro_feedback_path);
    }
    if (params.free_plus_url) {
      Domestika.free_plus_modal_auto.handle("courses", params.free_plus_url);
    }
    this.SectionsNavigation(params.course_purchased);
  };

  SectionsNavigation = (coursePurchased) => {
    if (coursePurchased) {
      return Domestika.sticky.stick_in_parent("#js-course-navigation", ".js-main-content");
    }
    return Domestika.promo_header.handle();
  };
}

Domestika.courseUnitsController = new CourseUnits();

let { params } = document.querySelector("[data-params]").dataset;
params = JSON.parse(params);
// Init Show
Domestika.courseUnitsController.init(params);
